import {
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-invite-success-dialog',
  templateUrl: './invite-success-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class InviteSuccessDialogComponent {
  constructor(
    public bsModalRef: BsModalRef<InviteSuccessDialogComponent>
  ) {}
}
